export const SubscriptionQueryKey = {
    subscriptionPlan: () => ['subscription-plan'],
    billingProducts: (products: string[]) => ['billing', 'products', products.join(',')],
    checkBilling: () => ['billing', 'check'],
}
